import React from 'react';
import BaseEntityList from './BaseEntityList';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { Module } from 'data/terra/Module';
import { BaseEntityItem } from './BaseEntityList/Model';

function ListModule() {
  const { modules } = useSelector((state: RootState) => state.common);
  const displayModules = modules.map(m => toModuleWrapper(m));

  return (
    <BaseEntityList<ModuleWrapper>
      entityName="Module"
      entities={displayModules}
      itemsPerRow={6}
      onEntitySelected={() => {}}
    />
  );
}

interface ModuleWrapper extends BaseEntityItem {
  module: Module;
}

function toModuleWrapper(module: Module): ModuleWrapper {
  return {
    id: module.id,
    code: `${module.product.code}:${module.platform.code}`,
    name: module.description,
    module,
  };
}

export default ListModule;
